import React, { FunctionComponent } from 'react';
import { CompanyContent } from '../../../types/specialShow';

type Props = {
  content: CompanyContent;
  hoverIcon: string;
};

export const Presentation: FunctionComponent<Props> = ({ content, hoverIcon }) => {
  return (
    <>
      {/* 企業ロゴ + 企業名 + 募集中 */}
      <a href={`/companies/${content.id}`} className="article-card">
        <p className="article-card-author">
          <span className="article-card-author-logo">
            <img src={content.icon} alt="企業のロゴ写真" />
          </span>
          <span className="article-card-author-name" style={{ display: "table-cell", paddingTop: 0 }}>
            {content.name}
            {content.hasReleasedRecruitment && (
              <span className="company-index-card-author-support" style={{ display: "inline-block" }}>
                募集中
              </span>
            )}
          </span>
        </p>
      </a>

      {/* カバー画像 */}
      <a href={`/companies/${content.id}`} className="article-card">
        <h2 className="article-card-heading article-card-heading-pc"></h2>
        <div className="article-card-img">
          <img
            src={content.coverImage}
            alt="企業のカバー写真"
          />
          <div className="article-card-hover">
            <img src={hoverIcon} alt="ホバーした際のアイコン画像" />
          </div>
        </div>
      </a>

      {/* 説明文 */}
      <p className="company-index-card-text">
        {content.profileInformationDescription}
      </p>
    </>
  );
};
